import React from 'react'
import { connect } from 'react-redux'
import { uploadImage } from '../../actions/avatarImage'
import { CircularProgress } from '@material-ui/core'

class AvatarImageUploadButton extends React.Component {
  state = {
    selectedFile: null,
    spin: false
  }
  onDrop = file => {
    this.props.dispatch(uploadImage(file.target.files[0], 'avatar'))
  }
  componentDidMount() {
    this.props.updateUser()
  }

  render() {
    return (
      <div>
        {this.props.updatingUser ? (
          <div
            style={{
              // backgroundColor: 'rgba(237,67,106,1)',
              borderRadius: '20px',
              // padding: '5px 4px',
              position: 'relative',
              bottom: '145px',
              left: '120px',
              color: '#fff'
            }}
            className="pointer"
          >
            <CircularProgress
              style={{
                color: '#fff'
              }}
            />
          </div>
        ) : (
          <div style={{ height: 0 }}>
            <div
              style={{
                backgroundColor: 'rgba(237,67,106,1)',
                borderRadius: '20px',
                padding: '5px 4px',
                position: 'relative',
                bottom: '145px',
                left: '120px'
              }}
              className="pointer"
              onClick={() => {
                document.getElementById('file-upload').click()
              }}
            >
              <i className="material-icons">add_a_photo</i>
            </div>
            <input
              type="file"
              onChange={e => this.onDrop(e, 'upload-photo-button')}
              style={{
                opacity: 0,
                padding: '10px',
                display: 'none',
                width: '10px'
              }}
              id="file-upload"
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser
  }
}
const mapActionsToProps = dispatch => {
  return {
    updateUser: () => dispatch({ type: 'USER::UPDATING_USER', payload: false }),
    dispatch
  }
}
const connector = connect(mapStateToProps, mapActionsToProps)

export default connector(AvatarImageUploadButton)
